import React, { useState, useEffect } from 'react';
//import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Aux from '../../hoc/beesaux/beesaux';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { Stitch, UserPasswordCredential, UserPasswordAuthProviderClient } from 'mongodb-stitch-browser-sdk'
import {
Redirect, Link
} from 'react-router-dom';
import { openDB } from 'idb/with-async-ittr.js';
//import lzwCompress from 'lzwcompress';
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from '../../components/MySnackbarContentWrapper'

import { patternizedDecompressor } from '../../shared/utility';
import ReactGA from 'react-ga';


const client = Stitch.initializeDefaultAppClient('ntn-dxcvz');




const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  signinlinkdiv: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  footer: {

 padding: theme.spacing.unit * 4,
 marginTop: '1em',
 borderTop: 'solid 1px cornflowerblue',
 backgroundColor: '#000011'
},
footerTextOverwrite: {
color: '#adadad',
},
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
});



const signin = props => {

  const [epos, setEpos] = useState('');
    const [wagwoord, setWagwoord] = useState('');
    const [resetPasswordMode, setResetPasswordMode] = useState(false);
    const [authSucc, setauthSucc] = useState(false);
    const [showSuccessMsg, setshowSuccessMsg] = useState(false);
    const [showErrorMsg, setshowErrorMsg] = useState(false);
    const [signinbutton_pressable, setsigninbutton_pressable] = React.useState(true)
 //  state = {
 //    epos : '',
 //    wagwoord: '',
 // }
//Signin function here



const pleaseSignIn = async (e) => {
  e.preventDefault();
  setsigninbutton_pressable(false)
  let epos2 = epos;
  let wagwoord2 = wagwoord;
  const app = Stitch.defaultAppClient
  //console.log(app)
  const credential = new UserPasswordCredential(epos2, wagwoord2)
  await app.auth.loginWithCredential(credential)
  .then(authedUser => {console.log(`successfully logged in with id: ${authedUser.id}`); console.log(authedUser); props.setUserRef(authedUser); /*props.fetchNodesRef(); props.fetchAnomaliesRef();*/ setauthSucc(true); getNodesFromEitherIDBorCloud(); } )
  .catch(err => console.error(`login failed with error: ${err}`))
}

const pleaseResetPassword = async (e) => {
    e.preventDefault();
  const emailPassClient = Stitch.defaultAppClient.auth
    .getProviderClient(UserPasswordAuthProviderClient.factory);
  emailPassClient.sendResetPasswordEmail(epos).then(() => {
    setshowSuccessMsg(true);
    console.log("Successfully sent password reset email!");
  }).catch(err => {
    console.log("Error sending password reset email:", err);
    setshowErrorMsg(true);
  });
}


// useEffect(() => {
//   // Your code here
//
//
//
// }, []);

async function getNodesFromEitherIDBorCloud() {
  //let's see if a database connection exists.
  const db = await openDB('Nodes', 1, {
  upgrade(db) {
    // Create a store of objects
    const store = db.createObjectStore('nodes', {
      keyPath: 'id',
      autoIncrement: true,
    });
  },
  });
  let counts = await db.count("nodes");

  if(counts > 0)
  {
    //console.log("registered that nodes already are in idb")
    retrieveNodesFromIDB();
    const app = Stitch.defaultAppClient
    // app.callFunction("getCustomUserData", [1]).then(res=>{
    //   // props.user.p = "dsadasd"
    //   // console.log(res);
    //   // let p = this.props.user
    //   // p.top10 = res
    //   // this.props.setUserRef(p)
    // })
  }
  else { //database does not exist, fetch and assign.
    //console.log("found no nodes in idb")
    props.fetchNodesRef();
    // const app = Stitch.defaultAppClient
    // app.callFunction("getCustomUserData", [1]).then(res=>{
    //
    //   console.log(res);
    //   // let p = this.props.user
    //   // p.top10 = res
    //   // this.props.setUserRef(p)
    // })


  }



}

async function retrieveNodesFromIDB() {

  try {
    const db = await openDB('Nodes', 1, {
      upgrade(db) {
        // Create a store of objects
        const store = db.createObjectStore('nodes', {
          // The 'id' property of the object will be the key.
          keyPath: 'id',
          autoIncrement: true,
        });
      },
    });

    const dbnodesorganized = await openDB('NodesOrganized', 1, {
        upgrade(dbnodesorganized) {
          // Create a store of objects
          const store = dbnodesorganized.createObjectStore('no', {
            // The 'id' property of the object will be the key.
            keyPath: 'id',
            autoIncrement: true,
            // If it isn't explicitly set, create a value by auto incrementing.
          });
          // Create an index on the 'date' property of the objects.
        },
      });

    //const value = await db.get(storeName, key);
    let nds = await db.getAll('nodes')
    props.setNodesRef(nds[0].nodes);

    let nst = await dbnodesorganized.getAll('no');
    props.setNodesSymbolTableRef(nst[0])
    //console.log("finished")
    //console.log(db);
    // db.count('nodes').then(res => {
    //
    //   console.log(res)});

  } catch (e) {

alert("The following indexedDB error occured: ", e);
  }
}

async function burnDataEntriesToIndexedDBOrGetThemAndSetIntoMemory() {

  const db = await openDB('DataEntriesOrganizedPPP', 1, {
  upgrade(db) {
    // Create a store of objects
    const store = db.createObjectStore('deo', {
      keyPath: 'id',
      autoIncrement: true,
    });
  },
  });


  let counts = await db.count("deo");

  if(counts === 0) // if there is no items in the store, let's go calculate and insert the symbol tree dataebtries
  {
    let obj = {};
    let counter = 0;
    let currentSymbolOrLetter = "";
    let arr = []; //a reusable array we will use to copy when necessary
    const app = Stitch.defaultAppClient
    let result = await client.callFunction("kryDataEntriesAllesVirIDB");
    let idasstring = "";
    for(let y in result)
    {
      idasstring = result[y]._id.toString();

      try{//attempt decompression if necessary.
        //result[y].lzw = JSON.parse(lzwCompress.unpack(result[y].lzw));

        result[y].dataentry = patternizedDecompressor(result[y].dataentry, props.patterns);

        //if(idasstring === "604621b3d62f01996f9b7fae")
        //{

          //result[y].lzw = {"blocks":[{},{},{"key":"d812f","text":"Iruka Dolphin Sana","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}
        //   result[y].lzw = {"blocks":[{},{},{"key":"d812f","text":"Look at this nice math. y-x2","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":28,"style":"BOLD"},{"offset":0,"length":28,"style":"ITALIC"},{"offset":0,"length":28,"style":"UNDERLINE"},{"offset":0,"length":22,"style":"STRIKETHROUGH"},{"offset":27,"length":1,"style":"SUPERSCRIPT"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"System.out.println(\"Hello\");","type":"code","depth":0,"inlineStyleRanges":[{"offset":0,"length":28,"style":"fontsize-24"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"Look at this strange font","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":25,"style":"fontsize-24"},{"offset":0,"length":25,"style":"fontfamily-Georgia"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"Item 1","type":"ordered-list-item","depth":0,"inlineStyleRanges":[{"offset":0,"length":6,"style":"fontsize-24"},{"offset":0,"length":6,"style":"fontfamily-Georgia"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"Item 2","type":"ordered-list-item","depth":0,"inlineStyleRanges":[{"offset":0,"length":6,"style":"fontsize-24"},{"offset":0,"length":6,"style":"fontfamily-Georgia"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"Item 3","type":"ordered-list-item","depth":0,"inlineStyleRanges":[{"offset":0,"length":6,"style":"fontsize-24"},{"offset":0,"length":6,"style":"fontfamily-Georgia"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"dlc1t","text":"asdasda","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":7,"style":"fontsize-24"},{"offset":0,"length":7,"style":"fontfamily-Georgia"}],"entityRanges":[],"data":{"text-align":"right"}},{"key":"d812f","text":"highlithed","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":10,"style":"fontsize-24"},{"offset":0,"length":10,"style":"fontfamily-Georgia"},{"offset":0,"length":10,"style":"color-rgb(0,168,133)"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"char count ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":11,"style":"fontsize-24"},{"offset":0,"length":11,"style":"fontfamily-Georgia"},{"offset":0,"length":11,"style":"color-rgb(0,168,133)"}],"entityRanges":[],"data":{}},{"key":"d812f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"2o0de","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":1}],"data":{}},{"key":"d812f","text":"❎","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"d812f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"548er","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":2}],"data":{}},{"key":"d812f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"d812f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"d812f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"d812f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"2jfjr","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"text-align":"right"}}],"entityMap":{"0":{"type":"LINK","mutability":"MUTABLE","data":{"url":"https://www.charactercountonline.com/","targetOption":"_blank"}},"1":{"type":"EMBEDDED_LINK","mutability":"MUTABLE","data":{"src":"https://www.charactercountonline.com/","height":"auto","width":"auto"}},"2":{"type":"IMAGE","mutability":"MUTABLE","data":{"src":"https://tse3.mm.bing.net/th?id=OIP.O3IeUAbjUFzwMSUsMPQMxAHaEN&pid=Api&P=0&w=297&h=170","height":"auto","width":"auto"}}}}
        // }



        if(currentSymbolOrLetter != result[y].node.charAt(0) && (counter != 0)) // both ifs and else we moved inside the try because things like ACTIONS will bug since they dont have a node
        {
    
          //obj[currentSymbolOrLetter] = [...arr];
          arr = []; //clear array for use for new symbol or letter
          counter = 0;
          // tx it
          currentSymbolOrLetter = result[y].node.charAt(0).toString();
        }
        if(obj[result[y].node.charAt(0)]) // if there is an array get it to push to it.
        {
          result[y]._id = idasstring;
          obj[result[y].node.charAt(0)].push(result[y])
          counter++;
        }
        else { // no array at that letter yet.
    
          obj[result[y].node.charAt(0)] = [];
          result[y]._id = idasstring;
          obj[result[y].node.charAt(0)].push(result[y]);
          counter++;
        }



      }
      catch(err)
      {
        //console.error("could not decompress, legacy mode handled.", err)
      }

    



    }
    await db.add('deo', obj);
    props.setDataEntriesSymbolTableRef(obj);
  }
  else { // if the entries already exist we just need to get them.

//console.log("entered else");
    let desymboltable = await db.get('deo', 1);

    //console.log(desymboltable)




    props.setDataEntriesSymbolTableRef(desymboltable);
  }



}

async function burnCustomDataToIndexedDBOrGetThemAndSetIntoMemory() {

  const db = await openDB('CustomData', 1, {
  upgrade(db) {
    // Create a store of objects
    const store = db.createObjectStore('custom', {
      keyPath: 'id',
      autoIncrement: true,
    });
  },
  });
  let counts = await db.count("custom");


  if(counts === 0) // if there is no items in the store, let's go calculate and insert the symbol tree dataebtries
  {
    const app = Stitch.defaultAppClient
    let result = await client.callFunction("getCustomUserData");

    //console.log(result)
  //  result.favorites =
    result.favorites.reverse();
    for(let x = 0; x < result.favorites.length; x++)
    {
      result.favorites[x]._id = result.favorites[x]._id.valueOf() + '';

    }
    await db.add('custom', result);
    props.setCustomDataRef(result);
    //props.setDataEntriesSymbolTableRef(obj);
  }
  else { // if the entries already exist we just need to get them.

//console.log("entered else");
    let customdata = await db.get('custom', 1);

    //console.log(desymboltable)




    props.setCustomDataRef(customdata);
  }



}

async function burnAnomaliesToIndexedDBOrGetThemAndSetIntoMemory() {

  const db = await openDB('Anomalies', 1, {
  upgrade(db) {
    // Create a store of objects
    const store = db.createObjectStore('anomalies', {
      keyPath: 'id',
      autoIncrement: true,
    });
  },
  });
  let counts = await db.count("anomalies");


  if(counts === 0) // if there is no items in the store, let's go calculate and insert the symbol tree dataebtries
  {
    const app = Stitch.defaultAppClient
    let result = await client.callFunction("kryAnomalies");

    props.setAnomaliesRef(result);



    //console.log(result)
  //  result.favo
    await db.add('anomalies', result);
    //props.setCustomDataRef(result);
    //props.setDataEntriesSymbolTableRef(obj);
  }
  else { // if the entries already exist we just need to get them.

//console.log("entered else");
    let anoms = await db.get('anomalies', 1);

    //console.log(desymboltable)




    props.setAnomaliesRef(anoms);
  }



}




const saveEmailInState = (e) => {
  //this.setState({epos: e.target.value})
  setEpos(e.target.value)
  //console.log(e.target.value);

}
const saveWagwoordInState = (e) => {
  //this.setState({wagwoord: e.target.value})
  //console.log(e.target.value);
  setWagwoord(e.target.value);

}

const forgotpassword = (e) => {
  //this.setState({epos: e.target.value})
  //console.log("clicked forgot password")
  setResetPasswordMode(true);

}

const clickedsignin = (e) => {
  //this.setState({epos: e.target.value})
  //console.log("clicked forgot password")
  setResetPasswordMode(false);

}

const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setshowSuccessMsg(false);
    setshowErrorMsg(false)

  };



    const { classes } = props;
    let passwordfield = (resetPasswordMode) ? false : <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">Password</InputLabel>
                <Input name="password" type="password" id="password" onChange={saveWagwoordInState}autoComplete="current-password" />
              </FormControl>;

    let forgotpasswordfield = (resetPasswordMode) ? <div className={classes.signinlinkdiv}><a style ={{textDecoration: 'underline', color: '#512da8', cursor: 'pointer'}} onClick={clickedsignin} >Sign in?</a></div> : <a style ={{textDecoration: 'underline', color: '#512da8', cursor: 'pointer'}} onClick={forgotpassword} >Forgot Password?</a>

    let signinbuttonorresetpasswordbutton = (resetPasswordMode) ? <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={(e)=>pleaseResetPassword(e)}
              >
              Reset Password
              </Button>
               :
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={(e)=>pleaseSignIn(e) }
                disabled={!signinbutton_pressable}
              >
                Sign in
              </Button>
  let successmessage = <Snackbar anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }} open={showSuccessMsg} autoHideDuration={6000}onClose={handleClose}>
                        <MySnackbarContentWrapper
                          onClose={handleClose}
                          variant="success"
                          message="Successfully sent account confirmation email!"
                        /></Snackbar>
 let errormessage = <Snackbar
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right',
                            }}
                            open={showErrorMsg}
                            autoHideDuration={6000}
                            onClose={handleClose}
                          >
                            <MySnackbarContentWrapper
                              onClose={handleClose}
                              variant="error"
                              message={"An error occured during the password reset process."}
                            />
                          </Snackbar>
    let placeholder =
    <main className={classes.main}>
      <CssBaseline />
      <Paper className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {resetPasswordMode ? "Reset Password" : "Sign in"}
        </Typography>
        <form className={classes.form}>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="email">Email Address</InputLabel>
            <Input id="email" name="email" type="email" autoComplete="email" onChange= {saveEmailInState}autoFocus />
          </FormControl>
          {passwordfield}
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
          {forgotpasswordfield}
          <Link style ={{textDecoration: 'underline', color: '#512da8', cursor: 'pointer'}} to= "/signup">
          Sign Up
          </Link>
          </div>

          {signinbuttonorresetpasswordbutton}
        </form>
      </Paper>
      {successmessage}
      {errormessage}
    </main>





    if(authSucc || client.auth.isLoggedIn)
    {


      ReactGA.initialize('G-Q9LNBT9EW5', {
        debug: true,
        titleCase: false,
        gaOptions: {
          userId: client.auth.currentUser
        }
      });
      ReactGA.pageview('/signin');

      //console.log("sdasdasda")

      //console.log(`successfully logged in with id: ${client.auth.currentUser.id}`);
      props.setUserRef(client.auth.currentUser);
      burnDataEntriesToIndexedDBOrGetThemAndSetIntoMemory();
      getNodesFromEitherIDBorCloud();
      burnCustomDataToIndexedDBOrGetThemAndSetIntoMemory();
      burnAnomaliesToIndexedDBOrGetThemAndSetIntoMemory();

      return <Redirect to="/main" />


    }


    return (
        <Aux>
            {placeholder}
        </Aux>
    );

  }


const mapStateToProps = state => {
    return {
       user: state.signIn.user,
       patterns: state.signIn.patterns
    }
  }
const mapDispatchToProps = dispatch => {
    return {
      // fetchAlertsRef: (user) => dispatch(actions.fetchAlerts(user)),
      // fetchAlertsClosedRef: (user) => dispatch(actions.fetchAlertsClosed(user)),
      setUserRef: (user) => dispatch(actions.setUser(user)),
      fetchNodesRef: () => dispatch(actions.fetchNodes()),
      //fetchAnomaliesRef: () => dispatch(actions.fetchAnomalies()),
      setAnomaliesRef: (s) => dispatch(actions.setAnomalies(s)),
      setNodesRef: (nodes) => dispatch(actions.setNodes(nodes)),
      setDataEntriesSymbolTableRef: (st) => dispatch(actions.setDataEntriesSymbolTable(st)),
      setCustomDataRef: (st) => dispatch(actions.setCustomData(st)),
      setNodesSymbolTableRef: (nodesymboltabletoset) => dispatch(actions.setNodesSymbolTable(nodesymboltabletoset))
      //callSomeFunctionFromStitchRef: () => dispatch(actions.callSomeFunctionFromStitch()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler( withStyles(styles)(signin) ));
